import React from "react";
import "./castingCall.css";
import {
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  IconButton
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

const SearchFilter = ({ searchInputs, setSearchInputs, handleSearch }) => {
  const handleInputChange = (name, value) => {
    setSearchInputs((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
    handleSearch();
  };

  return (
 
<FormControl
  sx={{
    m: 1,
    width: "600px",
    maxWidth: "420px",
    '@media (max-width:600px)': {
      maxWidth: "100%",  
      padding: "0 16px", 
    },
  }}
  variant="standard"
>
        {/* Shortened InputLabel with more clarity */}
        <InputLabel htmlFor="search-input">
          Search by Job Title, Category, Company, or Zip Code
        </InputLabel>
        <Input
          id="search-input"
          value={searchInputs.name}
          onChange={(e) => handleInputChange("name", e.target.value)}
          // endAdornment={
          //   <InputAdornment position="end">
          //     <IconButton>
          //       <SearchIcon />
          //     </IconButton>
          //   </InputAdornment>
          // }
        />
      </FormControl> 
  );
};

export default SearchFilter;
